module.exports = __webpack_public_path__ + "img/austincouncilJPG.8e3816b1.jpg";